import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TZ3224Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TZ3224IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_504)">
        <rect width="32" height="24" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V24H32V0H0Z"
          fill="#3195F9"
        />
        <mask
          id="mask0_1813_504"
          mask-type="luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="32"
          height="24"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H32V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1813_504)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24L32 0H0Z"
            fill="#73BE4A"
          />
          <path
            d="M-1.82144 25.4392L-1.12748 26.4789L-0.0878046 25.7849L36.1731 1.58147L37.2128 0.887505L36.5188 -0.152167L34.2982 -3.47912L33.6042 -4.51879L32.5645 -3.82483L-3.6964 20.3786L-4.73607 21.0726L-4.04211 22.1123L-1.82144 25.4392Z"
            fill="#272727"
            stroke="#FFD018"
            strokeWidth="2.5"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1813_504">
          <rect width="32" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TZ3224Icon;
